import { noop } from 'underscore';
import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Constants } from '@bingads-webui-theme-2018/theme-fluent';
import { useResponsiveSize } from '@adscore/with-responsive-size';
import { useIntersectionObserver } from '@bingads-webui-campaign-react/pmax-landing-utils';

import { DynamicAdCover } from './dynamic-ad-cover';
import { getLandingPageCoverStyles } from './styles/landing-page-cover-styles';

export function LandingPageCover({
  onClickSignUp,
  onClickClaimCoupon,
  signUpUrlWithCacheId,
  setCacheId,
  setShowAdPreviewPlaceholder,
  websiteInputRef,
  methodsContainerRef,
  logger,
}) {
  const classes = useDefaultStyles(getLandingPageCoverStyles);
  const displayMode = useResponsiveSize(Constants.ResponsiveSizeBreakpoints);
  const ref = useRef();

  const onScrollToView = useCallback(() => {
    logger.trace('LandingPageCover scrolled into view');
  }, [logger]);

  useIntersectionObserver({
    ref,
    onScrollToView,
    options: { threshold: 0.2 },
  });

  return (
    <div
      ref={ref}
      className={classNames('landing-page-cover', classes.background, classes[`background-${displayMode}`])}
      role="main"
    >
      <DynamicAdCover
        onClickSignUp={onClickSignUp}
        onClickClaimCoupon={onClickClaimCoupon}
        signUpUrlWithCacheId={signUpUrlWithCacheId}
        setCacheId={setCacheId}
        setShowAdPreviewPlaceholder={setShowAdPreviewPlaceholder}
        websiteInputRef={websiteInputRef}
        methodsContainerRef={methodsContainerRef}
        logger={logger}
      />
    </div>
  );
}

LandingPageCover.propTypes = {
  onClickSignUp: PropTypes.func.isRequired,
  onClickClaimCoupon: PropTypes.func.isRequired,
  signUpUrlWithCacheId: PropTypes.string.isRequired,
  setCacheId: PropTypes.func.isRequired,
  setShowAdPreviewPlaceholder: PropTypes.func,
  websiteInputRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  methodsContainerRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element),
  }),
  logger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }),
};

LandingPageCover.defaultProps = {
  setShowAdPreviewPlaceholder: noop,
  websiteInputRef: { current: null },
  methodsContainerRef: { current: null },
  logger: {
    trace: noop,
  },
};
